import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useCenterStudents({ adminView = false } = {}) {
    const { request } = useAuth();
    const queryClient = useQueryClient();

    const studentsQuery = useQuery({
        queryKey: ['centerStudents', adminView],
        queryFn: () =>
            request
                .get(adminView ? '/centerStudent/all' : '/centerStudent/my')
                .then((res) => res.data),
    });

    const addStudentMutation = useMutation({
        mutationFn: (formData) => request.post('/centerStudent/add', formData),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['centerStudents'] }),
    });

    const updateStudentMutation = useMutation({
        mutationFn: (formData) => request.put('/centerStudent/update', formData),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['centerStudents'] }),
    });

    const deleteStudentMutation = useMutation({
        mutationFn: (id) => request.delete('/centerStudent/delete', { data: { id } }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['centerStudents'] }),
    });

    return {
        students: studentsQuery?.data?.students || [],
        isStudentsLoading: studentsQuery.isLoading,

        addStudent: addStudentMutation.mutateAsync,
        isAddingStudent: addStudentMutation.isPending,

        updateStudent: updateStudentMutation.mutateAsync,
        isUpdatingStudent: updateStudentMutation.isPending,

        deleteStudent: deleteStudentMutation.mutateAsync,
        isDeletingStudent: deleteStudentMutation.isPending,
    };
}
